import { IApplicationState } from '../../../../../types/types';
import { IBoardTheme } from '../../../../../store/model/board/types';
import { getAuthUserMetaMyWork } from '../../../../../store/model/selectors/getAuthUserMetaMyWork';

export const getMyWorkTheme = (
    state: IApplicationState
): IBoardTheme => {
    return getAuthUserMetaMyWork(state).theme;
};
